import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import * as ObjectUtils from 'util';
import { SiteStepperEnum } from 'src/app/shared';
import { SiteService, SiteStepperService, } from 'src/app/services/index';
import { SiteModel, SiteStepperModel, Hierarchy, FeatureItemFlatNode, FeatureItemNode } from 'src/app/models/index';
import { MatDialog, MatDialogConfig, MatTreeFlatDataSource } from '@angular/material';
import { AlertService, Constants, DateService, ActionModeEnum } from 'src/app/shared/index';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { Subject } from 'rxjs';
import { AddNodeDetailModalComponent } from './add-node-detail-modal/add-node-detail-modal.component';
import { AddNodeInfoModalComponent } from './add-node-info-modal/add-node-info-modal.component';
import * as cloneDeep from 'lodash/cloneDeep';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { FlatTreeControl } from '@angular/cdk/tree';

@Component({
  selector: 'app-click-and-navigation-details',
  templateUrl: './click-and-navigation-details.component.html',
  styleUrls: ['./click-and-navigation-details.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClickAndNavigationDetailsComponent extends Hierarchy implements OnInit, AfterViewInit {
  @ViewChild('tree') tree;
  nodeType = Constants.NODE_TYPE;
  parentSubject: Subject<any> = new Subject();
  processForm: FormGroup;
  siteId: string;
  siteModel: SiteModel;
  virtualGroupNames: any;
  virtualGroupsConfiguredForSite = [];
  commissionRemark: any;
  copyToLayoutNavigationFeatureRadio: string;
  layoutNavigationFeatureTreeData: any;
  treeConfiguration: any;
  treeData = [];
  loadONTreeData: any;
  displayedColumns = ['index', 'virtualGroup'];
  treeType = {
    STATIC_TREE: 'STATIC_TREE',
    LOAD_ON_TREE: 'LOAD_ON_TREE',
    LAYOUT_NAVIGATION_TREE: 'LAYOUT_NAVIGATION_TREE'
  };
  maxTreeLevel = 6;
  nodeInfoModalMode_newFirst = 1;
  nodeInfoModalMode_new = 2;
  nodeInfoModalMode_edit = 3;
  newNodeIdInc = 0;
  divClassName = 'splitImg';
  // Tree Configuration
  selectedMetersRId = [];
  selectedProcessesRId = [];
  selectedMetersRId_staticTree = [];
  selectedProcessesRId_staticTree = [];
  selectedMetersRId_loadONTree = [];
  selectedProcessesRId_loadONTree = [];
  currentProcessTreeType = undefined;
  selectedMetersRId_layoutNavigationTree = [];
  selectedProcessesRId_layoutNavigationTree = [];
  selectedTreeType: any;
  //
  meters: any;
  processes: any;
  modalForm: any;
  nodeInfoModalMode = ActionModeEnum.Creating;
  currentNode: any;
  //
  copyLayoutRadio: any;
  expandedNodeSet = new Set<string>();
  dragging = false;
  expandTimeout: any;
  expandDelay = 1000;
  randomId = 1;
  constructor(private siteStepperService: SiteStepperService, private siteService: SiteService,
    public dialog: MatDialog, private alertService: AlertService,
    private commonService: CommonService,
    private dataService: DataService,
    private cdRef: ChangeDetectorRef, private fb: FormBuilder) {
    super();
    this.processForm = this.fb.group({
      virtualGroupNamesCtr: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(25), this.noWhitespace]],
    });
  }
  public noWhitespace(control: FormControl) {
    if ((control.value as string) && (control.value as string).indexOf(' ') >= 0) {
      return { 'whitespace': true }
    }
    return null;
  }
  ngOnInit() {
    this.siteStepperService.getStepperSubject().subscribe(data => {
      if (data.selectedIndex === SiteStepperEnum.ClickAndNavigationDetails && !ObjectUtils.isNullOrUndefined(data.siteModel)) {
        this.siteId = data.siteModel.siteId;
        this.siteModel = data.siteModel;
        // this.fakeData();
        this.initData();
      }
    });
    this.siteService.getNodeInfoSubject().subscribe(value => {
      switch (this.nodeInfoModalMode) {
        case ActionModeEnum.Creating:
          this.currentNode = value.nodeData;
          this.selectedMetersRId = value.selectedMetersRId;
          this.selectedProcessesRId = value.selectedProcessesRId;
          this.layoutNavigationFeatureTreeData = this.dataSource.data;
          this.reloadTree();
          break;
        case ActionModeEnum.CreatingFirstLevel:
          this.layoutNavigationFeatureTreeData = value.nodeData;
          this.selectedMetersRId = value.selectedMetersRId;
          this.selectedProcessesRId = value.selectedProcessesRId;
          this.reloadTree();
          break;
        case ActionModeEnum.Editing:
          this.currentNode = value.nodeData;
          this.selectedMetersRId = value.selectedMetersRId;
          this.selectedProcessesRId = value.selectedProcessesRId;
          this.updateNode(this.dataSource.data, value.nodeData);
          break;
        default:
          break;
      }
    });
  }
  private updateNode = (data: any, nodeData: any) => {
    for (let i = 0; i < data.length; i++) {
      const node = data[i];
      // if (node.RId === nodeData.RId) {
      if (node.nodeId === nodeData.nodeId) {
        Object.assign(node, nodeData);
        break;
      }
      if (node.nodes !== undefined && node.nodes !== null && node.nodes.length > 0) {
        this.updateNode(node.nodes, nodeData);
      }
    }
    this.layoutNavigationFeatureTreeData = this.dataSource.data;
  }
  ngAfterViewInit() {
    this.cdRef.detectChanges();
    this.tree.treeControl.expandAll();
  }
  private initData = () => {
    this.getExistingVirtualGroupsForSite();
    this.getCommissionRemark();
    this.getMetersBySiteIdAndMeterRoles();
    this.getProcessAndLoadsBySiteId();
    this.getTreeConfiguration();
  }
  // Action buttons
  public previousStep = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(new SiteStepperModel(SiteStepperEnum.TreeConfiguration, this.siteModel));
  }
  getExistingVirtualGroupsForSite() {
    this.siteService.getVirtualGroupsForSite(this.siteId).subscribe(data => {
      if (data.length > 0) {
        this.virtualGroupsConfiguredForSite = data;
      }
    });
  }
  private getMetersBySiteIdAndMeterRoles = () => {
    // tslint:disable-next-line:max-line-length
    this.siteService.getMetersBySiteIdAndMeterRoles(this.siteId, ['Mains', 'DG', 'UPS', 'Load', 'Harmonic', 'PDB', 'Solar']).subscribe(data => {
      this.meters = data;
    });
  }
  private getProcessAndLoadsBySiteId = () => {
    this.siteService.getProcessAndLoadsBySiteId(this.siteId, true).subscribe(data => {
      this.processes = data;
    });
  }

  private getTreeConfiguration = () => {
    this.dataSource.data = [];
    this.siteService.getTreeConfiguration(this.siteId, [
      'treeData',
      'loadONTreeData',
      'layoutNavigationFeatureTreeData'
    ]).subscribe(data => {
      if (data) {
        this.treeConfiguration = data;
        if (data.treeData !== undefined && data.treeData !== null && data.treeData !== 'null') {
          this.treeData = JSON.parse(data.treeData);
          // build selected meters and processes
          for (let i = 0; i < this.treeData.length; i++) {
            this.getSelectedMeterRecursive(this.treeData[i], this.selectedMetersRId_staticTree);
            this.getSelectedProcessRecursive(this.treeData[i], this.selectedProcessesRId_staticTree);
          }
        }
        if (data.loadONTreeData !== undefined && data.loadONTreeData !== null && data.loadONTreeData !== 'null') {
          this.loadONTreeData = JSON.parse(data.loadONTreeData);
          // build selected meters and processes
          for (let i = 0; i < this.loadONTreeData.length; i++) {
            this.getSelectedMeterRecursive(this.loadONTreeData[i], this.selectedMetersRId_loadONTree);
            this.getSelectedProcessRecursive(this.loadONTreeData[i], this.selectedProcessesRId_loadONTree);
          }
        }
        if (data.layoutNavigationFeatureTreeData !== undefined && data.layoutNavigationFeatureTreeData !== null &&
          data.layoutNavigationFeatureTreeData !== 'null') {
          this.layoutNavigationFeatureTreeData = JSON.parse(data.layoutNavigationFeatureTreeData);
          // build selected meters and processes
          for (let i = 0; i < this.layoutNavigationFeatureTreeData.length; i++) {
            this.getSelectedMeterRecursive(this.layoutNavigationFeatureTreeData[i], this.selectedMetersRId_layoutNavigationTree);
            this.getSelectedProcessRecursive(this.layoutNavigationFeatureTreeData[i], this.selectedProcessesRId_layoutNavigationTree);
          }
          // this.layoutNavigationFeatureTreeData = data.layoutNavigationFeatureTreeData;
          this.parentSubject.next(this.layoutNavigationFeatureTreeData[0]);

          if (this.layoutNavigationFeatureTreeData[0] !== undefined) {
            this.dataSource.data = this.buildFileTree(this.layoutNavigationFeatureTreeData[0], this.dataSource.data, null);
          }
          this.tree.treeControl.expandAll();
        }
      }
    });
  }

  private getSelectedMeterRecursive = (node: any, selectedMetersRId: any) => {
    if (node.meterRId !== undefined) {
      this.selectedMetersRId.push(node.meterRId);
    }
    if (node.nodes !== undefined && node.nodes.length > 0) {
      for (let i = 0; i < node.nodes.length; i++) {
        this.getSelectedMeterRecursive(node.nodes[i], selectedMetersRId);
      }
    }
  }
  private getSelectedProcessRecursive = (node: any, selectedProcessesRId: any) => {
    if (node.processRId !== undefined) {
      this.selectedProcessesRId.push(node.processRId);
    }
    if (node.nodes !== undefined && node.nodes.length > 0) {
      for (let i = 0; i < node.nodes.length; i++) {
        this.getSelectedProcessRecursive(node.nodes[i], selectedProcessesRId);
      }
    }
  }
  addNewVirtualGroupForSite() {
    const t = this;
    const params = {
      'SiteID': t.siteId,
      'VirtualGroupName': t.virtualGroupNames
    };

    if (t.virtualGroupNames !== '' && t.virtualGroupNames !== undefined) {
      t.siteService.addVirtualGroupForSite(params).subscribe(data => {
        t.getExistingVirtualGroupsForSite();
        let msg = '';
        if (data.result === 'Success') {
          msg = 'Added Virtual group Successfully..!!';
          t.alertService.showSuccess(msg);
        } else if (data.result === 'Fail') {
          // msg = 'Failed to add Virtual Group..!!';
          t.alertService.showError(data.message);
        } else {
          t.alertService.showError('Virtual Group already present');
          // alert('Virtual Group already present..!!');
        }
        t.virtualGroupNames = '';
      });
    } else {
      t.alertService.showError('Virtual group name cannot be NULL..!!');
    }
  }
  // Tree Congfiguration expand
  copyToLayoutNavigationFeatureRadioChange(value: string) {
    // this.copyToLayoutNavigationFeatureRadio = value;
    if (value === 'true') {
      this.copyLayoutRadio = true;
      this.layoutNavigationFeatureTreeData = cloneDeep(this.treeData);
      this.reloadTree();
    }
    else {
      if (this.copyLayoutRadio) {
        this.copyLayoutRadio = false;
        this.layoutNavigationFeatureTreeData = null;
        this.reloadTree();
      }
      else if (JSON.stringify(this.layoutNavigationFeatureTreeData) === JSON.stringify(this.treeData)) {
        this.layoutNavigationFeatureTreeData = null;
        this.reloadTree();
      }
    }
    // if (this.copyToLayoutNavigationFeatureRadio === 'true') {
    //   this.layoutNavigationFeatureTreeData = Object.assign([], this.treeData);
    // }
  }
  private reloadTree = () => {
    this.dataSource.data = [];
    if (this.layoutNavigationFeatureTreeData[0] !== undefined) {
      this.dataSource.data = this.buildFileTree(this.layoutNavigationFeatureTreeData[0], this.dataSource.data, null);
    }

    this.tree.treeControl.expandAll();
  }
  // Commission Remark expand
  getCommissionRemark() {
    this.siteService.getCommissionRemark(this.siteId).subscribe(data => {
      if (data) {
        this.commissionRemark = data.data;
      }
    });
  }
  submitCommissionRemark() {
    const t = this;
    t.siteService.saveCommissionRemark(t.siteId, t.commissionRemark).subscribe(data => {
      if (data === true) {
        t.alertService.showSuccess(Constants.MESSAGE.Save_success);
      } else {
        t.alertService.showError(Constants.MESSAGE.Save_failure);
      }
    });
  }
  public initTree = (treeType: any) => {
    this.setScopeVariablesByTreeType(treeType);
    this.nodeInfoModalMode = ActionModeEnum.CreatingFirstLevel;
    const dialogConfig: MatDialogConfig = {
      // height: '80%',
      width: '40%',
      // tslint:disable-next-line:max-line-length
      data: {
        meters: this.meters, processes: this.processes,
        virtualGroupsConfiguredForSite: this.virtualGroupsConfiguredForSite,
        selectedMetersRId: this.selectedMetersRId, selectedProcessesRId: this.selectedProcessesRId,
        actionMode: this.nodeInfoModalMode
      }
    };
    // Open View Existing Tags Accordion
    this.openNodeInfoModal(dialogConfig);
  }

  private setScopeVariablesByTreeType = (treeType: any) => {
    if (treeType === this.treeType.STATIC_TREE) {
      this.selectedMetersRId = this.selectedMetersRId_staticTree;
      this.selectedProcessesRId = this.selectedProcessesRId_staticTree;
    } else if (treeType === this.treeType.LOAD_ON_TREE) {
      this.selectedMetersRId = this.selectedMetersRId_loadONTree;
      this.selectedProcessesRId = this.selectedProcessesRId_loadONTree;
    } else if (treeType === this.treeType.LAYOUT_NAVIGATION_TREE) {
      this.selectedMetersRId = this.selectedMetersRId_layoutNavigationTree;
      this.selectedProcessesRId = this.selectedProcessesRId_layoutNavigationTree;
    }
    this.currentProcessTreeType = treeType;
  }
  openSiteDetailReport() {
    const url = this.commonService.getgenerateSiteReportUrl(this.siteId);
    this.dataService.getPDF(url, true).subscribe((response) => {
      if (response.byteLength > 0) {
        const file = new Blob([response], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, '_blank');
      } else {
        this.alertService.message = 'No data response !';
        this.alertService.showError();
      }

    });
    // window.open(url, '_blank');
  }

  buildFileTree(obj: any, nodes: any, currentSelected: any): any {
    const node = Object.assign({}, obj);
    node.nodeType = obj.nodeType;
    node.index = obj.index;
    node.nodeId = obj.nodeId;
    node.id = this.randomId++;
    node.level = obj.level;
    if (currentSelected != null && currentSelected.nodeId === obj.nodeId) {
      node.selected = true;
    }
    if (obj.nodes.length > 0) {
      node.nodes = [];
      for (let i = 0; i < obj.nodes.length; i++) {
        const element = obj.nodes[i];
        element.index = i;
        node.nodes = this.buildFileTree(element, node.nodes, currentSelected);
      }
    }
    return nodes.concat(node);
  }

  public featureLeafItemSelectionToggle(node: any): void {
    // this.setCurrentNode(node);
    // alert('click and navigation tree');
  }
  public editNode = (node: any, treeType: any) => {
    // console.log(node);
    // node.title = 'test';
    this.bindModalForm(node);
    this.currentNode = node;
    this.nodeInfoModalMode = ActionModeEnum.Editing;
    const dialogConfig: MatDialogConfig = {
      // height: '80%',
      width: '40%',
      // tslint:disable-next-line:max-line-length
      data: {
        meters: this.meters, processes: this.processes,
        virtualGroupsConfiguredForSite: this.virtualGroupsConfiguredForSite,
        selectedMetersRId: this.selectedMetersRId, selectedProcessesRId: this.selectedProcessesRId,
        actionMode: this.nodeInfoModalMode, modalForm: this.modalForm
      }
    };
    this.openNodeInfoModal(dialogConfig);
  }
  public newSubItem = (node: any, treeType: any) => {
    this.currentNode = node;
    this.selectedTreeType = treeType;
    // Check later
    // if(scope.depth() >= scope.$treeScope.maxDepth){
    // 	return;
    // }
    this.setScopeVariablesByTreeType(treeType);
    this.nodeInfoModalMode = ActionModeEnum.Creating;
    const dialogConfig: MatDialogConfig = {
      // height: '80%',
      width: '40%',
      // tslint:disable-next-line:max-line-length
      data: {
        meters: this.meters, processes: this.processes,
        virtualGroupsConfiguredForSite: this.virtualGroupsConfiguredForSite,
        selectedMetersRId: this.selectedMetersRId, selectedProcessesRId: this.selectedProcessesRId,
        actionMode: this.nodeInfoModalMode, nodeData: node
      }
    };
    this.openNodeInfoModal(dialogConfig);
  }
  // Check later
  public removeNodeItem = (node: any, treeType: any) => {
    this.setScopeVariablesByTreeType(treeType);
    this.unselectMeterOrProcess(node);
    const parentNode = this.getParent(node);
    if (parentNode !== null) {
      for (let i = 0; i < parentNode.nodes.length; i++) {
        const tempNode = <any>parentNode.nodes[i];
        if (tempNode.index !== undefined && tempNode.index === node.index) {
          parentNode.nodes.splice(i, 1);
          break;
        }
      }
      this.layoutNavigationFeatureTreeData = this.dataSource.data;
    } else {
      this.layoutNavigationFeatureTreeData = [];
    }
    this.reloadTree();
  }
  private findNodeAndRemove = (data: any, rid: any) => {
    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      if (item.RId === rid) {
        console.log('Found:v' + item);
        item.nodes = [];
        break;
      }
      if (item.nodes.length > 0) {
        this.findNodeAndRemove(item.nodes, rid);
      }
    }
  }
  private getParent = (node: any) => {
    const currentLevel = this.treeControl.getLevel(node);
    if (currentLevel < 1) {
      return null;
    }
    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.treeControl.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
  }
  private unselectMeterOrProcess = (nodeData: any) => {
    if (nodeData.nodeType === this.nodeType.TEXT) {
      for (let i = 0; i < nodeData.nodes.length; i++) {
        this.unselectMeterOrProcess(nodeData.nodes[i]);
      }
    } else if (nodeData.meterRId !== undefined) {
      for (let i = 0; i < this.selectedMetersRId.length; i++) {
        if (this.selectedMetersRId[i] === nodeData.meterRId) {
          this.selectedMetersRId.splice(i, 1);
        }
      }
    } else if (nodeData.processRId !== undefined) {
      for (let i = 0; i < this.selectedProcessesRId.length; i++) {
        if (this.selectedProcessesRId[i] === nodeData.processRId) {
          this.selectedProcessesRId.splice(i, 1);
        }
      }
    }
  }

  private bindModalForm = (node: any) => {
    let nodeName = null; let meterRId = null;
    let meterId = null; let processRId = null; let selectedVirtualGroup = null; let hasAttachment = false;
    switch (node.nodeType) {
      case 'TEXT': {
        nodeName = node.title;
        hasAttachment = node.hasAttachment;
        break;
      }
      case 'METER': {
        meterRId = node.meterRId;
        meterId = node.meterId;
        break;
      }
      case 'PROCESS': {
        processRId = node.processRId;
        break;
      }
      case 'VIRTUAL_GROUP': {
        selectedVirtualGroup = node.title;
        hasAttachment = node.hasAttachment;
        break;
      }
      default: {
        break;
      }
    }
    // tslint:disable-next-line:max-line-length
    this.modalForm = { nodeType: node.nodeType, nodeName: nodeName, meterId: meterId, meterRId: meterRId, processRId: processRId, selectedVirtualGroup: selectedVirtualGroup, hasAttachment: hasAttachment, nodeData: node };
  }

  private openNodeInfoModal = (dialogConfig: MatDialogConfig) => {
    // Open View Existing Tags Accordion
    this.dialog.open(AddNodeInfoModalComponent, dialogConfig);
  }

  saveTreeConfiguration() {
    const nullStr = null;
    this.treeConfiguration.treeData = nullStr;
    this.treeConfiguration.loadONTreeData = nullStr;
    this.treeConfiguration.inverterTreeData = nullStr;
    this.treeConfiguration.genericTreeData = nullStr;
    this.treeConfiguration.layoutNavigationFeatureTreeData = JSON.stringify(this.layoutNavigationFeatureTreeData);
    this.siteService.saveTreeConfiguration(this.siteId, this.treeConfiguration).subscribe(data => {
      this.treeConfiguration = data;
      this.alertService.showSuccess(Constants.MESSAGE.Save_success);

      // Notify update for upload image tree
      this.parentSubject.next(JSON.parse(this.treeConfiguration.layoutNavigationFeatureTreeData)[0]);
    });
  }

  private rememberExpandedTreeNodes(
    treeControl: FlatTreeControl<FeatureItemFlatNode>,
    expandedNodeSet: Set<string>
  ) {
    if (treeControl.dataNodes) {
      treeControl.dataNodes.forEach((node) => {
        if (treeControl.isExpandable(node) && treeControl.isExpanded(node)) {
          // capture latest expanded state
          expandedNodeSet.add(node.nodeId.toString());
        }
      });
    }
  }
  /**
   * This constructs an array of nodes that matches the DOM,
   * and calls rememberExpandedTreeNodes to persist expand state
   */
  visibleNodes(): FeatureItemNode[] {
    this.rememberExpandedTreeNodes(this.treeControl, this.expandedNodeSet);
    const result = [];

    function addExpandedChildren(node: FeatureItemNode, expanded: Set<string>) {
      result.push(node);
      if (expanded.has(node.nodeId.toString())) {
        node.nodes.map(child => addExpandedChildren(child, expanded));
      }
    }
    this.dataSource.data.forEach(node => {
      addExpandedChildren(node, this.expandedNodeSet);
    });
    return result;
  }

  /**
   * Handle the drop - here we rearrange the data based on the drop event,
   * then rebuild the tree.
   * */
  drop(event: CdkDragDrop<string[]>) {
    // console.log('origin/destination', event.previousIndex, event.currentIndex);
    // ignore drops outside of the tree
    if (!event.isPointerOverContainer) { return; }

    // construct a list of visible nodes, this will match the DOM.
    // the cdkDragDrop event.currentIndex jives with visible nodes.
    // it calls rememberExpandedTreeNodes to persist expand state
    const visibleNodes = this.visibleNodes();

    // deep clone the data source so we can mutate it
    const changedData = JSON.parse(JSON.stringify(this.dataSource.data));
    // recursive find function to find siblings of node
    function findNodeSiblings(arr: Array<any>, nodeId: string): Array<any> {
      let result, subResult;
      arr.forEach(item => {
        if (item.nodeId.toString() === nodeId) {
          result = arr;
        } else if (item.nodes) {
          subResult = findNodeSiblings(item.nodes, nodeId);
          if (subResult) { result = subResult; }
        }
      });
      return result;
    }

    // remove the node from its old place
    const node = event.item.data;
    const siblings = findNodeSiblings(changedData, node.nodeId.toString());
    const siblingIndex = siblings.findIndex(n => n.nodeId === node.nodeId);
    const nodeToInsert: FeatureItemNode = siblings.splice(siblingIndex, 1)[0];

    // determine where to insert the node
    const nodeAtDest = visibleNodes[event.currentIndex];
    if (nodeAtDest.nodeId === nodeToInsert.nodeId) { return; }

    // determine drop index relative to destination array
    let relativeIndex = event.currentIndex; // default if no parent
    const nodeAtDestFlatNode = this.treeControl.dataNodes.find(n => nodeAtDest.nodeId === n.nodeId);
    const parent = this.getParentNode(nodeAtDestFlatNode);
    if (parent) {
      const parentIndex = visibleNodes.findIndex(n => n.nodeId === parent.nodeId) + 1;
      relativeIndex = event.currentIndex - parentIndex;
    }
    // insert node
    const newSiblings = findNodeSiblings(changedData[0].nodes, nodeAtDest.nodeId.toString());
    if (!newSiblings) { return; }
    newSiblings.splice(relativeIndex, 0, nodeToInsert);
    // rebuild tree with mutated data
    this.rebuildTreeForData(changedData);
  }

  rebuildTreeForData(data: any) {
    this.rememberExpandedTreeNodes(this.treeControl, this.expandedNodeSet);
    this.dataSource.data = data;

    // Update data to store into DB
    this.layoutNavigationFeatureTreeData = this.dataSource.data;

    this.forgetMissingExpandedNodes(this.treeControl, this.expandedNodeSet);
    this.expandNodesById(this.treeControl.dataNodes, Array.from(this.expandedNodeSet));
    this.treeData = cloneDeep(this.dataSource.data);
  }

  private forgetMissingExpandedNodes(
    treeControl: FlatTreeControl<FeatureItemFlatNode>,
    expandedNodeSet: Set<string>
  ) {
    if (treeControl.dataNodes) {
      expandedNodeSet.forEach((nodeId) => {
        // maintain expanded node state
        if (!treeControl.dataNodes.find((n) => n.nodeId.toString() === nodeId)) {
          // if the tree doesn't have the previous node, remove it from the expanded list
          expandedNodeSet.delete(nodeId);
        }
      });
    }
  }

  private expandNodesById(flatNodes: FeatureItemFlatNode[], nodeIds: string[]) {
    if (!flatNodes || flatNodes.length === 0) { return; }
    const idSet = new Set(nodeIds);
    return flatNodes.forEach((node) => {
      if (idSet.has(node.nodeId.toString())) {
        this.treeControl.expand(node);
        let parent = this.getParentNode(node);
        while (parent) {
          this.treeControl.expand(parent);
          parent = this.getParentNode(parent);
        }
      }
    });
  }
  private getParentNode(node: FeatureItemFlatNode): FeatureItemFlatNode | null {
    const currentLevel = node.level;
    if (currentLevel < 1) {
      return null;
    }
    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];
      if (currentNode.level < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  /**
   * Experimental - opening tree nodes as you drag over them
   */
  dragStart() {
    this.dragging = true;
  }
  dragEnd() {
    this.dragging = false;
  }
  dragHover(node: any) {
    if (this.dragging) {
      clearTimeout(this.expandTimeout);
      this.expandTimeout = setTimeout(() => {
        this.treeControl.expand(node);
      }, this.expandDelay);
    }
  }
  dragHoverEnd() {
    if (this.dragging) {
      clearTimeout(this.expandTimeout);
    }
  }
}
